import {
  Component,
  OnInit,
  Inject,
  ChangeDetectorRef,
  AfterViewInit,
  Optional,
} from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { ApiList } from "../../api";
import { DashboardService } from "../../dashboard.service";
import { DashboardPorletsService } from "../../dashboardPorlets.service";
import { throttle } from "lodash";
import { API_SERVICE_TOKEN, PBF_TOKEN } from "../../../service/InjectionToken";
import { DialogService } from "../../../service/dialog.service";
import { getTranslation } from "../../../utils/utils";

@Component({
  selector: "rs-data-mart-new",
  templateUrl: "./data-mart-new.component.html",
  styleUrls: ["./data-mart-new.component.scss"],
})
export class DataMartNewComponent implements OnInit, AfterViewInit {
  translation;
  userInfo;
  lang;
  entityType;
  config;

  public fatherList = [];
  public sonList = [];
  public grandsonList = [];
  public fatherId = "";
  public sonIds = [];
  public selectedAll = false;
  public orginGrandData = [];
  public disabled = false;
  public cacheEntityType = "";
  public isSelectAllDisabled = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DataMartNewComponent>,
    private dialogService: DialogService,
    public dialog: MatDialog,
    private api: ApiList,
    public dashboardService: DashboardService,
    public DashboardPorletsService: DashboardPorletsService,
    private ref: ChangeDetectorRef,
    @Optional() @Inject(PBF_TOKEN) public pbf: any,
    @Optional() @Inject(API_SERVICE_TOKEN) private http: any
  ) {}
  ngOnInit() {
    this.getInfo();
    this.getSources();
  }

  ngAfterViewInit(): void {
    this.pbf.introStep.next("next");
  }

  public getInfo() {
    this.translation = getTranslation();
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.lang = this.pbf.getLanguageParams();
    this.config =
      this.data && this.data.dashboard
        ? JSON.parse(this.data.dashboard.config)
        : {};
  }
  getSources() {
    const dataObj = {
      accountId: this.userInfo.accountId,
      language: this.lang,
      dashboardVersion: 2,
    };
    this.pbf.pageLoading = true;
    this.pbf.pageLoading_.next(true);
    this.http.post(this.api.urlList.GetSources, dataObj, (res) => {
      this.pbf.pageLoading = false;
      this.pbf.pageLoading_.next(true);
      if (res) {
        this.DashboardPorletsService.sourcesData[this.data.dashboard.id] = res;
        this.DashboardPorletsService.GetSourcesRes = res;
        this.fatherList = res;

        if (this.config.datamartId) {
          // this.disabled = true;
          this.fatherId = this.config.datamartId;
          this.sonIds = this.config.datamartViewId
            ? this.config.datamartViewId.split(",")
            : this.config.views
            ? this.config.views.map((item) => item.datamartViewId)
            : [];
          let datasource = res.find((el) => el.id == this.fatherId);
          if (datasource) {
            this.getdataMart(datasource, true);
            if (!this.cacheEntityType && this.config.datamartId) {
              this.cacheEntityType = this.entityType;
            }

            let dataview = datasource.views.filter((el) =>
              this.sonIds.includes(el.id)
            );
            this.handleItemChange(dataview, true);
            this.getSelectedAllStatus();
          }
        }
      }
    });
  }
  getSelectedAllStatus() {
    let num = 0;
    this.sonList.forEach((son) => {
      if (son.checked && son.langCode !== "FINANCIAL_FIGURES") {
        num++;
      }
    });
    if (num === this.sonList.length - 1) this.selectedAll = true;
    else this.selectedAll = false;
  }

  nextStep() {
    this.pbf.introStep.next("next");
  }

  getdataMart(item, isInit = false) {
    if (this.cacheEntityType && this.cacheEntityType === item.entityType) {
      return;
    }
    if (
      !isInit &&
      this.cacheEntityType &&
      this.cacheEntityType !== item.entityType
    ) {
      const _title =
        this.translation.ARE_YOU_SURE_TO_CHANGE_DATA_MART ||
        ".Are you sure to change entity type of data mart? Dashboard will be reset since entity type is changed.";
      const _no = this.translation.NO || ".NO";
      const _yes = this.translation.YES || ".YES";
      // const dialogRef = this.layoutUtilsService.alertElement(
      // 	this.translation.WARNING || ".WARNING",
      // 	_title,
      // 	_no,
      // 	_yes,
      // 	true,
      // 	true,
      // 	"480px",
      // 	"324px"
      // );
      const dialogRef = this.dialogService.showCommonDilaog({
        title: this.translation.WARNING || ".WARNING",
        description: _title,
        saveBtnLabel: _yes,
        cancelBtnLabel: _no,
      });
      dialogRef.afterClosed().subscribe((res) => {
        if (!res) {
          return;
        }
        this.setFatherId(item, isInit);
      });
      return;
    }
    if (!item) {
      return;
    }
    this.setFatherId(item, isInit);
  }

  private setFatherId(item, isInit) {
    this.fatherId = item.id;
    this.entityType = item.entityType;
    let isFiguresChecked = false;
    let isOtherChecked = false;
    if (
      item.views.find(
        (item) =>
          item.langCode === "FINANCIAL_FIGURES" && this.sonIds.includes(item.id)
      )
    ) {
      isFiguresChecked = true;
      this.isSelectAllDisabled = true;
    }
    if (
      item.views.find(
        (item) =>
          item.langCode !== "FINANCIAL_FIGURES" && this.sonIds.includes(item.id)
      )
    )
      isOtherChecked = true;

    this.sonList = item.views.map((item) => {
      let isDisabled =
        (isFiguresChecked && item.langCode !== "FINANCIAL_FIGURES") ||
        (item.langCode === "FINANCIAL_FIGURES" && isOtherChecked);
      return {
        ...item,
        checked:
          this.cacheEntityType && this.cacheEntityType !== this.entityType
            ? false
            : this.sonIds.includes(item.id),
        disabled:
          this.cacheEntityType && this.cacheEntityType !== this.entityType
            ? false
            : isDisabled,
      };
    });

    this.cacheEntityType = item.entityType;

    if (!isInit) {
      this.sonIds = [];
      this.grandsonList = [];
      this.orginGrandData = [];
      this.selectedAll = false;
      this.isSelectAllDisabled = false;
      if (this.cacheEntityType && this.cacheEntityType !== item.entityType) {
        this.sonList = item.views.map((item) => {
          return {
            ...item,
            checked: false,
            disabled: false,
          };
        });
      }
    }
  }

  handleItemChange(data, val?: boolean) {
    if (!data) return false;
    if (val) {
      if (Array.isArray(data)) {
        data.forEach((item) => {
          if (!this.sonIds.includes(item.id)) {
            this.sonIds.push(item.id);
          }
          if (Array.isArray(item.tables)) {
            item.tables.forEach((child) => {
              if (!this.grandsonList.some((el) => el.id === child.id)) {
                this.grandsonList.push({
                  ...child,
                });
              }
            });
          }
        });
      } else {
        // financial figures can’t be selected together with other groups
        if (data.langCode !== "FINANCIAL_FIGURES") {
          this.sonList.forEach((item) => {
            if (item.langCode === "FINANCIAL_FIGURES") item.disabled = true;
          });
        } else {
          if (
            !this.sonList.find(
              (item) => item.checked && item.langCode !== "FINANCIAL_FIGURES"
            )
          ) {
            this.sonList.forEach((item) => {
              if (item.langCode !== "FINANCIAL_FIGURES") item.disabled = true;
            });
            this.isSelectAllDisabled = true;
          }
        }
        data.tables.forEach((item) => {
          if (!this.grandsonList.some((el) => el.id === item.id)) {
            this.grandsonList.push({
              ...item,
            });
          }
        });
        if (!this.sonIds.includes(data.id)) {
          this.sonIds.push(data.id);
        }
      }
    } else {
      this.grandsonList = [];
      this.sonList.forEach((item) => {
        if (data.langCode === "FINANCIAL_FIGURES") {
          item.disabled = false;
          this.isSelectAllDisabled = false;
        }
        if (item.id == data.id) {
          item.checked = val;
        }
        if (item.checked) {
          item.tables.forEach((sonItem) => {
            if (!this.grandsonList.some((el) => el.id === sonItem.id)) {
              this.grandsonList.push({
                ...sonItem,
              });
            }
          });
        }
      });
      if (
        data.langCode !== "FINANCIAL_FIGURES" &&
        !this.sonList.find(
          (item) => item.checked && item.langCode !== "FINANCIAL_FIGURES"
        )
      ) {
        this.sonList.forEach((obj) => {
          if (obj.langCode === "FINANCIAL_FIGURES") obj.disabled = false;
        });
      }
      this.sonIds = this.sonIds.filter((item) => item != data.id);
    }
    this.getSelectedAllStatus();
    this.orginGrandData = JSON.parse(JSON.stringify(this.grandsonList));
    if (!this.ref["destroyed"]) {
      this.ref.markForCheck();
      this.ref.detectChanges;
    }
  }
  selectAll(val) {
    if (!val) {
      this.orginGrandData = [];
    }
    this.grandsonList = [];
    this.sonIds = [];
    this.sonList.forEach((item) => {
      if (item.langCode !== "FINANCIAL_FIGURES") item.checked = val;
      if (val) {
        if (item.langCode === "FINANCIAL_FIGURES") {
          item.disabled = true;
          return;
        }
        this.sonIds.push(item.id);
        item.tables.forEach((sonItem) => {
          if (!this.grandsonList.some((el) => el.id === sonItem.id)) {
            this.grandsonList.push({
              ...sonItem,
            });
          }
        });
      } else {
        if (item.langCode === "FINANCIAL_FIGURES") item.disabled = false;
      }
    });
    this.orginGrandData = JSON.parse(JSON.stringify(this.grandsonList));
  }

  public doFilter = throttle((val) => this.doSearch(val), 200);
  public doSearch(val) {
    let tempList = JSON.parse(JSON.stringify(this.orginGrandData));
    if (val) {
      this.grandsonList = tempList.filter((item) =>
        item.langValue.toLowerCase().includes(val.toLowerCase())
      );
    } else {
      this.grandsonList = tempList;
    }
  }
  // 保存弹窗筛选数据
  saveData() {
    this.pbf.introStep.next("complete");
    this.pbf.pageLoading = true;
    let config;
    let datamartViewCode = this.sonList.filter((el) =>
      this.sonIds.includes(el.id)
    );
    config = {
      datamartId: this.fatherId,
      datamartViewId: this.sonIds.join(","),
      views: datamartViewCode.map((e) => {
        return {
          datamartViewId: e.id,
          datamartViewCode: e.langCode,
        };
      }),
    };
    const entityList =
      this.data.dashboard.entityType === this.entityType
        ? this.DashboardPorletsService.entityList
        : [];

    const dataObj = {
      entityList,
      accountId: this.userInfo.accountId,
      userId: this.userInfo.id,
      dashboardId: this.data.dashboardId,
      dataMartTables: this.grandsonList,
      entityType: this.entityType || this.data.dashboard.entityType,
      config: JSON.stringify(config),
    };

    this.http.post(this.api.urlList.AddDataMartTables, dataObj, (res) => {
      if (res.status === "SUCCESS") {
        const _saveMessage =
          this.translation.DASHBOARD_PROPERTIES_SAVED ||
          ".DASHBOARD_PROPERTIES_SAVED";
        this.showToast(_saveMessage, "Success");
        this.config.datamartViewId = this.sonIds.join(",");
        this.config.views = [];
        this.sonList.forEach((item) => {
          this.sonIds.forEach((sonId) => {
            if (item.id === sonId) {
              this.config.views.push({
                datamartViewCode: item.langCode,
                datamartViewId: item.id,
              });
            }
          });
        });

        this.data.dashboard.config = JSON.stringify(this.config);
        if (this.data.edit) {
          this.DashboardPorletsService.portletFields_Temp = {};
        }
        if (
          entityList &&
          entityList.length &&
          this.data.dashboard.entityType === this.entityType
        ) {
          this.pbf.triggerDashboardRefresh.next({
            entityList,
            id: this.data.dashboard.id,
          });
          this.dialogRef.close();
          return;
        }

        this.DashboardPorletsService.GetDashboardV1(
          this.data.dashboardId,
          true,
          (res, portlets = []) => {
            this.dashboardService.changelayout.next({
              status: "true",
              id: this.data.dashboard.id,
            });
            this.pbf.pageLoading = false;
            this.dialogRef.close({
              push_btn: false,
              portlet: {},
              portlets,
              dashboard: res,
            });
            this.ref.markForCheck();
          }
        );
      } else {
        this.pbf.pageLoading = false;
        this.pbf.pageLoading_.next(true);
        this.ref.markForCheck();
        const _saveMessage = res.messages[0].message || "error";
        this.showToast(_saveMessage, "Error");
      }
    });
  }
  // toast msg
  public showToast(msg, status: "Success" | "Error") {
    this.dialogService.showNotification(msg, {
      status,
    });
  }
  // 关闭弹窗
  public closePopup() {
    this.dialogRef.close();
  }
}
